import { render, staticRenderFns } from "./hqglOfficeBaseBoardStyle.vue?vue&type=template&id=4c65bb31&scoped=true&"
import script from "./hqglOfficeBaseBoardStyle.vue?vue&type=script&lang=js&"
export * from "./hqglOfficeBaseBoardStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c65bb31",
  null
  
)

export default component.exports